export function isENSName(str) {
    const ensRegex = /^[a-zA-Z0-9-]{3,}\.eth$/;
    return ensRegex.test(str);
}
//# sourceMappingURL=ens.js.map